import RestAPI from '../../components/Common/restApi';

export default class PriceBookApi {
  static fetchPriceBookIndustries() {
    return RestAPI.get('/alpha/pricebook/industries');
  }

  static fetchPriceBookCategories(params) {
    return RestAPI.getWithQueryString('/alpha/pricebook/categories', params);
  }

  static fetchPriceBookIndustry(id) {
    return RestAPI.get(`/alpha/pricebook/industries/${id}`);
  }

  static fetchPriceBookCategory(id) {
    return RestAPI.get(`/alpha/pricebook/categories/${id}`);
  }

  static fetchPriceBookService(params, id) {
    return RestAPI.getWithQueryString(`/alpha/pricebook/services/${id}`, params);
  }

  static fetchMaterialCategory(id) {
    return RestAPI.get(`/alpha/pricebook/material_categories/${id}`);
  }

  static fetchPriceBookMaterial(params, id) {
    return RestAPI.getWithQueryString(`/alpha/pricebook/materials/${id}`, params);
  }

  static createIndustry(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/industries', params);
  }

  static editIndustry(params, id) {
    return RestAPI.updateWithFormData(`/alpha/pricebook/industries/${id}`, params);
  }

  static deleteIndustry(id) {
    return RestAPI.deleteWithFormData(`/alpha/pricebook/industries/${id}`);
  }

  static createCategory(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/categories', params);
  }

  static editCategory(params, id) {
    return RestAPI.updateWithFormData(`/alpha/pricebook/categories/${id}`, params);
  }

  static deleteCategory(id) {
    return RestAPI.deleteWithFormData(`/alpha/pricebook/categories/${id}`);
  }

  static fetchBreadCrumbInfo(id) {
    return RestAPI.get(`/alpha/pricebook/categories/${id}/bread_crumb_info`);
  }

  static fetchMaterialBreadCrumbInfo(id) {
    return RestAPI.get(`/alpha/pricebook/material_categories/${id}/bread_crumb_info`);
  }

  static fetchServices(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/services', params);
  }

  static fetchMaterials(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/materials', params);
  }

  static createMaterial(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/materials', params);
  }

  static editMaterial(params, id) {
    return RestAPI.updateWithFormData(`/alpha/pricebook/materials/${id}`, params);
  }

  static deleteMaterial(id) {
    return RestAPI.deleteWithFormData(`/alpha/pricebook/materials/${id}`);
  }

  static fetchServiceCategories() {
    return RestAPI.get('/pro/account/price_list/industries');
  }

  static fetchMeasurementUnits() {
    return RestAPI.get('/alpha/pricebook/services/available_measurement_units');
  }

  static createService(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/services', params);
  }

  static editService(params, id) {
    return RestAPI.updateWithFormData(`/alpha/pricebook/services/${id}`, params);
  }

  static deleteService(id) {
    return RestAPI.deleteWithFormData(`/alpha/pricebook/services/${id}`);
  }

  static changeServicesPricing(data) {
    return RestAPI.postWithFormData('/alpha/pricebook/services/change_price', data);
  }

  static reorderIndustries(industryUuids) {
    return RestAPI.postWithFormData('/alpha/pricebook/industries/reorder', { industry_uuids: industryUuids });
  }

  static reorderServices(categoryId, serviceIds) {
    return RestAPI.postWithFormData(`/alpha/pricebook/categories/${categoryId}/services/reorder`, {
      service_uuids: serviceIds,
    });
  }

  static reorderMaterials(categoryId, materialIds) {
    return RestAPI.postWithFormData(`/alpha/pricebook/material_categories/${categoryId}/materials/reorder`, {
      material_uuids: materialIds,
    });
  }

  static reorderCategories(categoryIds) {
    return RestAPI.postWithFormData('/alpha/pricebook/categories/reorder', { category_uuids: categoryIds });
  }

  static getLeavesCategories(industryUuid) {
    return RestAPI.get(`/alpha/pricebook/industries/${industryUuid}/available_categories`);
  }

  static getLeavesMaterialCategories() {
    return RestAPI.get('/alpha/pricebook/material_categories/available');
  }

  static searchServices(params) {
    return RestAPI.getWithQueryString('/alpha/pricebook/services/search', params);
  }

  static searchMaterials(params) {
    return RestAPI.getWithQueryString('/alpha/pricebook/materials/search', params);
  }

  static searchCategories(params) {
    return RestAPI.getWithQueryString('/alpha/pricebook/categories/search', params);
  }

  static searchMaterialCategories(params) {
    return RestAPI.getWithQueryString('/alpha/pricebook/material_categories/search', params);
  }

  static importCsv(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/services/import_csv', params);
  }

  static importMaterialsCsv(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/materials/import_csv', params);
  }

  static exportCsv() {
    return RestAPI.get('/alpha/pricebook/services/export');
  }

  static exportMaterialsCsv() {
    return RestAPI.get('/alpha/pricebook/materials/export');
  }

  static getMaterialCategories(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/material_categories', params);
  }

  static createMaterialCategory(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/material_categories', params);
  }

  static editMaterialCategory(params, id) {
    return RestAPI.updateWithFormData(`/alpha/pricebook/material_categories/${id}`, params);
  }

  static reorderMaterialCategories(materialCatergoryIds) {
    return RestAPI.postWithFormData('/alpha/pricebook/material_categories/reorder', {
      material_category_uuids: materialCatergoryIds,
    });
  }

  static deleteMaterialCategory(id) {
    return RestAPI.deleteWithFormData(`/alpha/pricebook/material_categories/${id}`);
  }

  static fetchTaxRates(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/tax_rates', params);
  }

  static upsertTaxRates(taxRates) {
    return RestAPI.updateWithFormData('/alpha/pricebook/tax_rates/upsert', { tax_rates_attributes: taxRates });
  }

  static fetchLaborRates(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/labor_rates', params);
  }

  static upsertLaborRates(laborRates) {
    return RestAPI.updateWithFormData('/alpha/pricebook/labor_rates/upsert', { labor_rates_attributes: laborRates });
  }

  static fetchMaterialMarkups(paginationParams) {
    return RestAPI.get('/alpha/pricebook/material_markups', paginationParams);
  }

  static upsertMaterialMarkups(materialMarkups) {
    return RestAPI.updateWithFormData('/alpha/pricebook/material_markups/upsert', {
      pricebook_material_markups_attributes: materialMarkups,
    });
  }

  static bulkMoveServices(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/services/bulk_move', params);
  }

  static bulkMoveMaterials(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/materials/bulk_move', params);
  }

  static calculateMaterialPrice(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/materials/calculate_price', params);
  }

  static calculateServicePrice(params) {
    return RestAPI.postWithFormData('/alpha/pricebook/services/calculate_price', params);
  }

  static fetchPricingContentBooks() {
    return RestAPI.get('/alpha/pricing_content/books');
  }

  static fetchPricingContentBooksWithStatus(params) {
    return RestAPI.getWithFormData('/alpha/pricebook/pricing_content/books', params);
  }

  static updatePricingContent() {
    return RestAPI.post('/alpha/pricebook/pricing_content/books/update_content');
  }

  static restoreSupplierService(service_uuid) {
    return RestAPI.postWithFormData(`/alpha/pricebook/services/restore_service`, { service_uuid: service_uuid });
  }

  static restoreSupplierMaterial(material_uuid) {
    return RestAPI.postWithFormData(`/alpha/pricebook/materials/restore_material`, { material_uuid: material_uuid });
  }

  static fetchPricingContentAvailableUpdate() {
    return RestAPI.get('/alpha/pricebook/pricing_content/books/available_update');
  }
}
